import { PayloadAction } from "@reduxjs/toolkit";
import { select } from "redux-saga/effects";
import { selectAuthAccountId } from "../../selectors/auth";
import { selectSelectedBrandAndActiveCompetitorIdsState } from "../../selectors/brands";
import { selectBrandWithCompetitorsState } from "../../selectors/brands";
import { BRANDS_MODELS_SCORE_DAILY_TABLE_NAME } from "../../const";
import { BRANDS_SCORE_DAILY_TABLE_NAME } from "../../const";
import { BrandScoreDailyRow } from "../types";
import { Brand } from "../../../types/brand";
import { supabase } from "../../../lib/supabase";
import { format, subDays } from "date-fns";
import { throwOnSupabaseError } from "../../../utils/errors";
import { call, put } from "redux-saga/effects";
import { applySagaError } from "../../utils/saga";
import { fetchOverviewScoresFromDailySuccess, fetchOverviewScoresFromDailyFailure } from "../slice";
import { rowsToScoreOverview, aggregateByBrand } from "../utils/overviewFromDaily";
import { FetchOverviewScoresFromDailyPayload } from "../payload.types";



export function* fetchOverviewScoresSaga(action: PayloadAction<FetchOverviewScoresFromDailyPayload>) {
    try {
        const {date, period, model_id} = action.payload;
        const userID: string | null = yield select(selectAuthAccountId);
        const brandIds: number[] = yield select(selectSelectedBrandAndActiveCompetitorIdsState);
        const brands: Brand[] = yield select(selectBrandWithCompetitorsState);
        const tableName = model_id ? BRANDS_MODELS_SCORE_DAILY_TABLE_NAME : BRANDS_SCORE_DAILY_TABLE_NAME;
        let rows: BrandScoreDailyRow[];
    
        if (date) {
            let query = supabase
                .from(tableName)
                .select("*")
                .eq("user_id", userID)
                .in("brand_id", brandIds)
                .eq("date", date)
                .order("date", { ascending: true });
    
            if (model_id) {
                query = query.eq("model_id", model_id);
            }
    
            const { data, error } = yield call(() => query);
    
            throwOnSupabaseError(error);
            
            rows = (data ?? []) as BrandScoreDailyRow[];
        } else if (period) {
            const endDate = new Date();
            const startDate = subDays(endDate, period);
            const startStr = format(startDate, "yyyy-MM-dd");
            const endStr = format(endDate, "yyyy-MM-dd");
            let query = supabase
                .from(tableName)
                .select("*")
                .eq("user_id", userID)
                .in("brand_id", brandIds)
                .gte("date", startStr)
                .lte("date", endStr)
                .order("date", { ascending: true });

            if (model_id) {
                query = query.eq("model_id", model_id);
            }

            const { data, error } = yield call(() => query);

            throwOnSupabaseError(error);

            const rawRows = (data ?? []) as BrandScoreDailyRow[];
            
            rows = aggregateByBrand(rawRows);
        } else {
            throw new Error("scores.fetchOverviewScoresFromDaily: expected date or period");
        }
    
        const result = rowsToScoreOverview(rows, brands);
        yield put(fetchOverviewScoresFromDailySuccess(result));
    } catch (error) {
        yield* applySagaError(error, {
            operationName: "scores.fetchOverviewScoresFromDaily",
            failureAction: fetchOverviewScoresFromDailyFailure,
        });
    }
  }